<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu"   background-color="#324157"
            text-color="#bfcbd9" active-text-color="#20a0ff" unique-opened router>
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template #title>
                            <i :class="item.icon"></i>
                            <span>{{ item.title }}</span>
                        </template>
                        <template v-for="subItem in item.subs">
                            <el-submenu v-if="subItem.subs" :index="subItem.index" :key="subItem.index">
                                <template #title>{{ subItem.title }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.subs" :key="i" :index="threeItem.index">
                                    {{ threeItem.title }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.index" :key="subItem.index">{{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">

                        <i :class="item.icon"></i>
                        <template #title>{{ item.title }}  <el-badge :value="$store.state.waitShUserNum" class="item" v-if="$store.state.waitShUserNum>0&&item.index.indexOf('AdminWaitShUsers')>-1"></el-badge></template>

                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
    import {admin_users_getWaitShNum } from '../../api';
    import {dealResult} from "../../api/common";

    export default {
    data() {
        return {
            items:[],
            lander:{},
        };
    },
    methods:{

        getWaitShNum(){
            let o={
                uid:this.lander.uid,
                token:this.lander.token,
            };
            admin_users_getWaitShNum(o).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.$store.dispatch('saveWaitShUserNum',res.data.obj);

                }
            })
        }

    },
    mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        if(this.lander.role=='100'){
            this.getWaitShNum();
            this.items=[
                // {
                //     icon: "el-icon-paperclip",
                //     index: "/AdminType",
                //     title: "板块管理",
                // },
                // {
                //     icon: "el-icon-s-order",
                //     index: "/AdminForum",
                //     title: "帖子管理",
                // },
                // {
                //     icon: "el-icon-chat-line-round",
                //     index: "/AdminComment",
                //     title: "评论管理",
                // },
                {
                    icon: "el-icon-user",
                    index: "/AdminWaitShUsers",
                    title: "待审核用户",
                },
                {
                    icon: "el-icon-user-solid",
                    index: "/AdminUsers",
                    title: "用户管理",
                },
                 {
                    icon: "el-icon-notebook-2",
                    index: "/EntityList",
                    title: "载体清单",
                },
                  {
                    icon: "el-icon-location",
                    index: "/AdminRegion",
                    title: "二级地区",
                },
                {
                    icon: "el-icon-message",
                    index: "/AdminEmail",
                    title: "邮件发送",
                },
                {
                    icon: "el-icon-document",
                    index: "/AdminTemplate",
                    title: "邮件模板",
                },
                 {
                    icon: "el-icon-s-promotion",
                    index: "/AdminOutbox",
                    title: "发件箱管理",
                },
                {
                    icon: "el-icon-collection",
                    index: "/AdminSendRecord",
                    title: "邮件发送记录",
                }
                // {
                //     icon: "el-icon-paperclip",
                //     index: "/AdminType?type=sub",
                //     title: "群组管理",
                // },

            ];
        }


        if(this.lander.role=='50')
            this.items=[

             {
                    icon: "el-icon-notebook-2",
                    index: "/EntityList",
                    title: "载体清单",
                },
                  {
                    icon: "el-icon-location",
                    index: "/AdminRegion",
                    title: "二级地区",
                },


        ];




    }


};
</script>

<style scoped>
.sidebar {
    display: block;
    position: absolute;
    left: 0;
    top: 70px;
    bottom: 0;
    overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
    width: 200px;
}
.sidebar > ul {
    height: 100%;
}
</style>
